import { useNavigate, useSearch } from "@tanstack/react-router"
import { useEffect, useRef } from "react"
import { trackEvent } from "@/lib/log"

export function AmazonConnect() {
  const query = useSearch({
    from: "/dashboard/amazon/connect",
  }) as any
  const navigate = useNavigate()

  const redirected = useRef(false)
  useEffect(() => {
    if (redirected.current) return
    redirected.current = true

    const amazonCode = query.code
    const integrationId = query.state

    if (amazonCode && integrationId) {
      trackEvent("received Amazon authorization code", { integrationId })
      navigate({
        to: "/integrations/$integrationId",
        params: { integrationId: String(integrationId) },
        search: { step: "3", amazonCode } as any,
      })
    } else {
      navigate({ to: "/" })
    }
  }, [query, navigate])

  return <div>Connecting your account...</div>
}
